// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import {Message} from 'element-ui'
import utils from './common/js/utils'
import constant from './common/js/constant'
import 'element-ui/lib/theme-chalk/index.css'
import './common/scss/index.scss'
import iView from 'iview';
import 'iview/dist/styles/iview.css';

import VueKindEditor from 'vue-kindeditor'
import 'kindeditor/kindeditor-all-min'
import 'kindeditor/themes/default/default.css'
import LightTimeline from 'vue-light-timeline'
import VueCropper from 'vue-cropper'



//-----plot 开始 ----------
// 注册组件
import Components from './components/ploter/'
Components.init()

// 注册插件
import Plugins from './plugins/'
Plugins.init()
//-----plot 结束 ----------

Vue.use(VueKindEditor)

Vue.use(LightTimeline)

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.use(utils);
Vue.use(Vuex);
Vue.use(iView);
Vue.use(VueCropper);
//const store = CreateStore();

axios.defaults.timeout = 30000; 
// 后台项目地址
axios.defaults.baseURL = window.config.domain;
//解决跨域
axios.defaults.withCredentials = true;
Vue.prototype.$http.defaults.withCredentials = true;
//axios请求
Vue.prototype.$axios = axios;
Vue.prototype.CONSTANT = constant;
// 统一 blob 下载（带 token，替代 window.open 直链下载，避免被 AccessFilter 拦截）
Vue.prototype.$downloadBlob = function (url, fallbackName) {
  const vm = this;
  return this.$axios({ method: 'get', url: url, responseType: 'blob' })
    .then(function (response) {
      let filename = fallbackName;
      const cd = response.headers['content-disposition'];
      if (cd) {
        const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
        if (m) filename = decodeURIComponent(m[1]);
      }
      if (!filename) {
        try {
          const src = new URL(url, window.location.origin).searchParams.get('src');
          if (src) filename = src.substring(src.lastIndexOf('/') + 1);
        } catch (e) {}
      }
      filename = filename || 'download';
      const contentType = response.headers['content-type'] || 'application/octet-stream';
      if (!/\.[a-z0-9]+$/i.test(filename)) {
        const extMap = {'application/pdf':'pdf','application/msword':'doc','application/vnd.ms-excel':'xls','application/vnd.ms-powerpoint':'ppt','application/zip':'zip','application/octet-stream':'bin','image/jpeg':'jpg','image/png':'png','image/gif':'gif','image/webp':'webp'};
        const ext = extMap[contentType];
        if (ext) filename += '.' + ext;
      }
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.setAttribute('download', filename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(function () {
      if (vm.$message) vm.$message.error('下载失败，请重试');
    });
};

//路由拦截（含菜单路由权限校验）
let menuAuthTipShown = false; // 同一次越权访问只弹一次提示，避免循环跳转导致 Message 堆叠
router.beforeEach((to, from, next) => {
  /**登录态 + 菜单路由权限校验 by li.xue 2019/1/25；菜单权限补充 2026-09-15 */
  if (to.path === '/') {
    // 不再仅依据本地 isLogin 标记盲目跳管理员首页：过期 token 会造成"闪一下 home 再被弹回"。
    // 直接进入登录页，由 Login.vue 校验 token 是否有效后再决定跳转（2026-09-28 修复）
    next();
    return;
  }
  if (to.matched.some(m => m.meta.auth) && localStorage.isLogin === 'TRUE') {
    // 首页及特殊公开页直接放行
    var whiteList = ['/index', '/lottery', '/lotteries'];
    if (whiteList.indexOf(to.path) > -1) {
      next();
      if (to.path === '/lottery' || to.path === '/lotteries') {
        setTimeout(function () { router.go(-1); }, 50);
      }
      return;
    }
    var menuPaths = store.getters.getMenuPaths || [];
    var menuReady = store.getters.getMenuReady;
    // 本次会话菜单尚未加载完成（首跳/刚登录/菜单树异步未返回）：先放行，避免用陈旧(上一次会话)的 localStorage 值误杀
    if (!menuReady || menuPaths.length === 0) {
      next();
      return;
    }
    // 判断是否拥有该菜单路由
    var norm = function (p) { return (p || '').replace(/\/+$/, ''); };
    var nTo = norm(to.path);
    var hasAuth = menuPaths.map(norm).indexOf(nTo) > -1;
    if (!hasAuth) {
      // 资源菜单树通常只登记到一/二级菜单，深层子路由（如 /exhibitor/booth/select/plan）是前端页面内导航；
      // 其授权父菜单（/exhibitor/booth/select）已在 menuPaths 中，则视为有权放行，避免误杀（2026-09-16 修复）
      hasAuth = menuPaths.some(function (p) {
        var np = norm(p);
        return np && nTo.indexOf(np + '/') === 0;
      });
    }
    if (hasAuth) {
      next();
    } else {
      try { console.warn('[路由守卫-无权限] to.path=', to.path, '| menuReady=', menuReady, '| menuPaths=', JSON.stringify(menuPaths)); } catch (e) {}
      if (!menuAuthTipShown) {
        Message.error('您没有该菜单的访问权限');
        menuAuthTipShown = true;
      }
      // 无权限：提示一次后留在当前页，不跳转（避免跳管理员首页、避免循环）
      next(false);
    }
    return;
  }
  next();
});
//添加请求拦截器
axios.interceptors.request.use(
  config => {
    //在发送请求之前做某事
    config.headers.PATHURL = router.currentRoute.path;
    config.headers.PATHNAME = encodeURI(router.currentRoute.name);
    if(config.url != '/login' && config.url != '/logout'
        && config.url.indexOf('/signin/sendMessage')>-1 && config.url.indexOf('/signin/sendMailEng')>-1
        && config.url.indexOf('/signin/getUsernameByMail')>-1 && config.url.indexOf('/signin/findByMail')>-1
        && config.url.indexOf('/signin/findByUsername')>-1 && config.url.indexOf('/signin/insertByVO')>-1
        && config.url.indexOf('/signin/findByUnscid/')>-1 && config.url.indexOf('/signin/getMailNum/')>-1
        && config.url.indexOf('/signin/sendMail')>-1 && config.url.indexOf('/signin/updateByVO')>-1
        ){
      var isLogin = localStorage.getItem('isLogin');
      if(isLogin != 'TRUE'){
        router.push({path: '/'});
      }
    }
    /**采用TOKEN验证方式  by li.xue */
    var token = localStorage.getItem("XTOKEN");
    if (token != null){
      config.headers.XTOKEN = token;
    }
      return config;
    },
  error => {
    //请求错误时做些事
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    //展示请求错误信息
    //错误提示键值对
    let code = response.data.code;
    if (code == '00000000') {
      return response;
    } else {
      if (code == '44444444') {
        localStorage.clear();
        Message.error('登录超时，请重新登录');
        router.push({name: 'login'});
      } else if (code == '55555555'){
        localStorage.clear();
        // Message.error('登录失效，请重新登录');
        router.push({name: 'login'});
      } else {
        return response;
      }
    }
  },
  error => {
    //请求超时跳转到登录页面
    if("Network Error" == error.message){
      localStorage.clear();
      router.push({name: 'login'});
    }
    Message.error({
      showClose: true,
      message: "error",
      type: 'error'
    });
    return Promise.reject(error);
  })


//plot:window.wrapHandshake =
window.wrapHandshake =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js